// extracted by mini-css-extract-plugin
export default {"container":"MainScreen_container__r1ffw"};